<div class="overview-card">
  <div class="header-container">
    <div class="title-container tw-items-center">
      <div class="tw-font-bold">{{ title }}</div>
      <div class="edit" mat-raised-button color="primary" *ngIf="!loading">
        <div class="edit-text-container" data-cy="edit-data-list" (click)="onEditClicked()">
          <span>Edit</span>
        </div>
      </div>
    </div>
  </div>
  <div class="content-container" *ngIf="!loading">
    <div *ngFor="let data of dataListHead; last as last">
      <div *ngIf="!checkIfArray(data.value) && !checkIfLongText(data.value)">
        <div class="content-item-container" attr.data-cy="{{getAttributeName(data.label)}}">
            <span class="tw-py-2 tw-leading-none">{{ data.label }}</span>
            <p [className]="data.cssClass + ' mb-0 tw-leading-none'">
              <span *ngIf="!!data.metadata?.extraLabel" [className]="data.metadata?.cssClass">{{ data.metadata?.extraLabel }}</span>
              <span [ngSwitch]="data.metadata?.pipe">
                <span *ngSwitchCase="'date'">{{ data.value | date }}</span>
                <span *ngSwitchCase="'phone'">+{{ data.metadata.phoneCountryCode }} {{ data.value | phone: data.metadata.countryCode }}</span>
                <span *ngSwitchCase="'percent'">{{ data.value | percentage }}</span>
                <span *ngSwitchCase="'ssn'">{{ data.value | ssn }}</span>
                <span *ngSwitchCase="'currency'">{{ data.value | currency }}</span>
                <span *ngSwitchCase="'number'">{{ data.value | number: '1.2-2' }}</span>
                <span *ngSwitchDefault>{{ data.value }}</span>
              </span>
              <span *ngIf="data.metadata?.link"><br><a href="{{data.metadata.link}}" target="_blank">Street View</a></span>
              <mat-icon *ngIf="data.metadata?.icon" [style.color]="data.metadata?.icon.color" matTooltip="{{ data.metadata?.icon.tooltip }}">{{ data.metadata?.icon.id }}</mat-icon>
            </p>
        </div>
        <hr *ngIf="!last">
      </div>
      <div class="content-item-container" *ngIf="checkIfArray(data.value)">
        <p class="mb-0">{{ data.label }}</p>
        <p>{{ data.value }}</p>
        <hr *ngIf="!last">
        <div class="content-item-container" *ngFor="let data of data.value">
          {{ data.label }}: {{ data.value }}
        </div>
      </div>
      <div *ngIf="!checkIfArray(data.value) && checkIfLongText(data.value)">
        <div class="column-content-item-container">
          <p class="mb-0">{{ data.label }}</p>
          <p class="long-text-value">{{ data.value }}</p>
        </div>
        <hr *ngIf="!last">
      </div>
    </div>
  </div>
  <div *ngIf="!loading">
    <mat-expansion-panel
      hideToggle
      (opened)="moreDetailsOpen = true"
      (closed)="moreDetailsOpen = false"
      *ngIf="displayLimit && dataList && dataList.length > displayLimit">
      <mat-expansion-panel-header>
        <div attr.data-cy="more-info-toggle-{{title}}" class="tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-normal tw-text-center tw-w-full">
          <button mat-button
            [color]="'primary'">
            {{ toggleTitle }}
            <mat-icon>{{ moreDetailsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
      </mat-expansion-panel-header>
      <div *ngFor="let data of dataListTail; last as last">
        <div class="content-item-container" *ngIf="!checkIfArray(data.value)" attr.data-cy="{{getAttributeName(data.label)}}">
          <p class="mb-0">{{ data.label }}</p>
          <p [className]="data.cssClass">
            <span [ngSwitch]="data.metadata?.pipe">
              <span *ngSwitchCase="'date'">{{ data.value | date }}</span>
              <span *ngSwitchCase="'phone'">+{{ data.metadata.phoneCountryCode }} {{ data.value | phone: data.metadata.countryCode }}</span>
              <span *ngSwitchCase="'percent'">{{ data.value | percentage }}</span>
              <span *ngSwitchCase="'ssn'">{{ data.value | ssn }}</span>
              <span *ngSwitchCase="'currency'">{{ data.value | currency }}</span>
              <span *ngSwitchCase="'number'">{{ data.value | number: '1.2-2' }}</span>
              <span *ngSwitchDefault>{{ data.value }}</span>
            </span>
          </p>
        </div>
        <div class="content-item-container" *ngIf="checkIfArray(data.value)">
            <p class="mb-0">{{ data.label }}</p>
            <div>
              <div>
                <div class="content-item-container-multiple" *ngFor="let data of data.value">
                  <p>{{ data.label }}&nbsp;&nbsp;{{ data.value }}</p>
                </div>
              </div>
            </div>
          </div>
          <hr *ngIf="!last">
      </div>
      </mat-expansion-panel>
  </div>
  <div *ngIf="loading" style="display: flex; justify-content: center; padding: 20px;">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
